module.exports = __webpack_public_path__ + "img/update-gb-whatsapp.c190ea34.webp";